/*!

=========================================================
* Argon Design System React - v1.1.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import { Link } from "react-router-dom";

// reactstrap components
import { Button, Container, Row, Col } from "reactstrap";

class Hero extends React.Component {
  render() {
    return (
      <>
        <div className="position-relative">
          {/* Hero for FREE version */}
          <section className="section bg-image section-hero section-shaped">
            <Container className="shape-container d-flex align-items-center py-lg">
              <div className="col px-0">
                <Row className="align-items-center justify-content-center">
                  <Col className="text-center" lg="8">
                    <img
                      alt="Chisp"
                      className="img-fluid mb-3"
                      src="/chisp.png"
                      style={{ width: "160px" }}
                    />
                    <h5
                      className="text-uppercase mb-5"
                      style={{ color: "#6ea982", letterSpacing: "2px" }}
                    >
                      One Platform. Infinite Insight.
                    </h5>
                    <div className="btn-wrapper">
                      <Button
                        className="btn-round mb-3 mb-sm-0 mr-sm-2"
                        color="primary"
                        size="lg"
                        to="/consulting"
                        tag={Link}
                      >
                        Data Consulting
                      </Button>
                      <Button
                        className="btn-round mb-3 mb-sm-0"
                        color="success"
                        size="lg"
                        to="/platform"
                        tag={Link}
                      >
                        IoT Platform
                      </Button>
                    </div>
                  </Col>
                </Row>
              </div>
            </Container>
            {/* SVG separator */}
            <div className="separator separator-bottom separator-skew zindex-100">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                preserveAspectRatio="none"
                version="1.1"
                viewBox="0 0 2560 100"
                x="0"
                y="0"
              >
                <polygon
                  className="fill-white"
                  points="2560 0 2560 100 0 100"
                />
              </svg>
            </div>
          </section>
        </div>
      </>
    );
  }
}

export default Hero;
